export const COMPENSATORY_TIME = '/compensatory_time/';